import React from 'react'
import style from "./index.module.scss"

interface IProps {
  text: string
  type?: 'green' | 'bule' | 'orange'
  className?: string
}

function Card ({ type = 'green', text, className }: IProps) {
  const types = `card-${type}`
  const cardClass = `${style.card} ${className} ${style[types]}`

  return (
    <div className={cardClass}>
      {text}
    </div>
  )
}

export default Card
